module.exports = __webpack_public_path__ + "files/76841b75cf2367fb787f4f4314d75ad0.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/ubuntu-bold-webfont.woff
 ** module id = 1024
 ** module chunks = 0
 **/